import React from 'react'
import { useState } from 'react'

import SeleccionarProductosBarcode from './SeleccionarProductosBarcode'
import ProductosSeleccionadosConfiguracion from './ProductosSeleccionadosConfiguracion'

const ProductosBarcode = ({ productos }) => {

    const [productosSeleccionados, setProductosSeleccionados] = useState([])
    const [funcion, setfuncion] = useState('ver')

    const cambiarFuncion = (fn) => setfuncion(fn)
    return (
        <div className='productos-barcode-container'>

            {
                {
                    'ver': <SeleccionarProductosBarcode setProductosSeleccionados={setProductosSeleccionados} productosSeleccionados={productosSeleccionados} productos={productos} cambiarFuncion={cambiarFuncion} />,
                    'configuracion': <ProductosSeleccionadosConfiguracion productosSeleccionados={productosSeleccionados} />
                }[funcion]
            }
        </div>

    )
}


export default ProductosBarcode